// ----------------------------------------------------------------------

// IF THIS TRANSLATION IS INCORRECT PLEASE IGNORE THIS AS THIS TRANSLATION IS FOR DEMO PURPOSES ONLY
// We are happy if you can help improve the translation by sending an email to support@minimals.cc.

// ----------------------------------------------------------------------
const year = new Date().getFullYear();
const vn = {
  demo: {
    title: `Vietnamese`,
    introduction: `Lorem Ipsum chỉ đơn giản là văn bản giả của ngành in ấn và sắp chữ. Lorem Ipsum đã trở thành văn bản giả tiêu chuẩn của ngành kể từ những năm 1500, khi một nhà in không xác định lấy một dãy loại và xáo trộn nó để tạo thành một cuốn sách mẫu. Nó đã tồn tại không chỉ năm thế kỷ, mà còn là bước nhảy vọt trong lĩnh vực sắp chữ điện tử, về cơ bản vẫn không thay đổi. Nó được phổ biến vào những năm 1960 với việc phát hành các tờ Letraset chứa các đoạn Lorem Ipsum, và gần đây hơn là với phần mềm xuất bản trên máy tính để bàn như Aldus PageMaker bao gồm các phiên bản của Lorem Ipsum.`,
  },
  docs: {
    hi: `Chào`,
    description: `Cần giúp đỡ？\n Vui lòng xem tài liệu của chúng tôi.`,
    documentation: `tài liệu`,
  },
  app: `ứng dụng`,
  user: `người dùng`,
  list: `danh sách`,
  edit: `chỉnh sửa`,
  shop: `cửa hàng`,
  blog: `blog`,
  post: `bài viết`,
  mail: `thư`,
  chat: `trò chuyện`,
  cards: `thẻ`,
  posts: `danh sách bài viết`,
  create: `tạo`,
  kanban: `bảng`,
  general: `chung`,
  banking: `ngân hàng`,
  booking: `đặt phòng`,
  profile: `hồ sơ`,
  account: `tải khoản`,
  product: `sản phẩm`,
  invoice: `hóa đơn`,
  details: `chi tiết`,
  checkout: `thanh toán`,
  calendar: `lịch`,
  analytics: `phân tích`,
  ecommerce: `thương mại điện tử`,
  management: `quản lý`,
  menu_level_1: `menu cấp 1`,
  menu_level_2a: `menu cấp 2a`,
  menu_level_2b: `menu cấp 2b`,
  menu_level_3a: `menu cấp 3a`,
  menu_level_3b: `menu cấp 3b`,
  menu_level_4a: `menu cấp 4a`,
  menu_level_4b: `menu cấp 4b`,
  item_disabled: `mục vô hiệu`,
  item_label: `mục nhãn`,
  item_caption: `mục chú thích`,
  item_external_link: `mục liên kết ngoài`,
  description: `mô tả`,
  other_cases: `Trường hợp khác`,
  item_by_roles: `mục theo vai trò`,
  only_admin_can_see_this_item: `Chỉ có quản trị viên mới có thể nhìn thấy mục này`,
  header: {
    about: "Về chúng tôi",
    contact: "Liên hệ",
    pricing: "Giá cả",
    ReportAbuse: "Báo cáo Lạm dụng",
    InvitationSystem: "Hệ thống Mời",
    verify_email: "Xác minh email",
    sign_in: "Đăng nhập",
    dashboard: "Bảng điều khiển",
    biolink_page: "Trang Biolink",
    admin: "Quản trị",
    logout: "Đăng xuất",
    sign_up: "Đăng ký",
    about_us: "Về chúng tôi",
    contact_us: "Liên hệ chúng tôi",
    payments_list: "Danh sách thanh toán",
  },
  footer: {
    terms_conditions: "Điều khoản & Điều kiện",
    privacy_policy: "Chính sách Bảo mật",
    copyright: "Bản quyền © " + year + " bil.bio",
    Update_cookies_preferences: "Quản lý cookie",
  },
  biolink_title: {
    edit: "Chỉnh sửa",
    delete: "Xóa",
    delete_cap: "XÓA",
    save_cap: "LƯU",
    view: "Xem",
    settings: "Cài đặt",
    duplicate: "Sao chép",
    your_link_is: "Đường link của bạn là",
    copy_to_clipboard: "Sao chép vào Clipboard",
    copied: "Đã sao chép",
    change_status: "Thay đổi Trạng thái",
    edit_user: "Chỉnh sửa người dùng",
    block: "Chặn",
    november: "Tháng 11",
    maximum: "Tối đa",
  },

  auth: {
    create_your_account: "Tạo tài khoản của bạn",
    signup_to_bilbio_and_create_your_biolink_now:
      "Đăng ký vào bilbio và tạo Biolink của bạn NGAY BÂY GIỜ!",
    pagename: "Tên trang",
    enter_page_name: "Nhập tên trang",
    enter_page_email: "Nhập địa chỉ Email",
    by_creating_an_account_you_agreeing_to_our:
      "Bằng cách tạo một tài khoản, bạn đồng ý với chúng tôi",
    log_in: "ĐĂNG NHẬP",
    create_account: "TẠO TÀI KHOẢN",
    hi_welcome_back: "Chào, Chào mừng trở lại!",
    enter_you_details_to_login_into_your_bilbio_account:
      "Nhập thông tin của bạn để đăng nhập vào tài khoản bilbio của bạn",
    enter_password: "Nhập mật khẩu",
    login: "ĐĂNG NHẬP",
    sign_up: "ĐĂNG KÝ",
    do_not_have_an_account: "Không có tài khoản?",
    page_name_required: "Yêu cầu tên trang",
    pass_required: "Yêu cầu mật khẩu",
    this_username_is_already_taken: "Tên người dùng này đã được sử dụng",
    page_name_cannot_contain_symbols: "Tên trang không thể chứa ký tự đặc biệt",
    forgot_your_password: "Quên mật khẩu",

  },
  Invitation_System: {
    More_than_a_todo_app: "Hơn một ứng dụng Todo",
    paragraph:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Impedit quam eum facere explicabo, dolorum sed consequuntur incidunt, culpa cum voluptatem, eaque consectetur saepe rerum dolor? Cum eius labore debitis minus.",
    thanks_for_siging: "Cảm ơn bạn đã đăng ký",
    verify_your_email: "Xác minh Email của bạn",
    confirm_email: "Vui lòng xác nhận rằng bạn muốn sử dụng địa chỉ email này",
    verify_email: "XÁC MINH EMAIL",
    bilbio_Account_activated: "Tài khoản Bill Bio đã được kích hoạt",
    hello: "Xin chào John",
    email_verified:
      "Cảm ơn bạn, Email của bạn đã được xác minh. Tài khoản của bạn đang hoạt động ngay bây giờ.",
    link_login_account:
      "Vui lòng sử dụng liên kết dưới đây để đăng nhập vào tài khoản của bạn",
    login_account: "ĐĂNG NHẬP TÀI KHOẢN",
    invite_friend: 'Mời bạn bè',
    invite_friend_cap: 'MỜI BẠN BÈ',
    you_have: 'Bạn có',
    credits: 'tín dụng',
    friend: 'Bạn bè',
    sent: 'đã gửi'
  },
  front_end_pages: {
    home_page: {
      hero_section: {
        main_title_part_one: "Xây dựng một liên kết duy nhất",
        main_title_part_two: "cho tất cả các liên kết của bạn",
        sub_title:
          "Tận dụng các nền tảng trực tuyến khác nhau để tương tác với những người có cùng sở thích, có được sự ti exposure, và thiết lập một hiện diện kỹ thuật số cho sự sáng tạo của bạn, tất cả từ Biolink của bạn.",
      },
      features_section: {
        biolink: "Biolink",
        create: "TẠO",
        create_your: "Tạo của bạn",
        unique: "duy nhất",
        sec_one_first_line:
          "Tạo trang liên kết cá nhân của bạn một cách dễ dàng chỉ trong vài giây.",
        sec_one_sec_line:
          "Thống nhất toàn bộ hiện diện trực tuyến của bạn thành một liên kết duy nhất.",
        sec_one_thired_line:
          "Một liên kết để chia sẻ mọi thứ với người theo dõi của bạn.",
        sec_one_four_line:
          "Cá nhân hóa biolinks của bạn, giữ chúng ngắn gọn và dễ chia sẻ.",
        customize: "TÙY CHỈNH",
        design: "Thiết kế",
        exceptional: "ngoại lệ",
        sec_two_first_line:
          "Tạo trang liên kết bio của bạn độc đáo và có thể tùy chỉnh cao với sự thuận lợi.",
        sec_two_sec_line:
          "Cá nhân hóa biolink của bạn với màu sắc và nhận diện thương hiệu tùy chỉnh.",
        sec_two_thired_line:
          "Trải nghiệm dễ dàng hơn với nhiều thành phần sẵn sàng sử dụng.",
        sec_two_four_line:
          "Thêm Instagram, Twitter, Snapchat, TikTok, Youtube, tay cầm truyền thông xã hội và hình ảnh khác.",
        share: "CHIA SẺ",
        add_your_biolink_to_your: "Thêm Biolink của bạn vào",
        social_media: "truyền thông xã hội",
        handles: "tay cầm",
        sec_thered_first_line:
          "Thêm URL biobil tùy chỉnh của bạn vào tất cả các nền tảng để tiếp cận khán giả của bạn.",
        sec_thered_sec_line:
          "Cá nhân hóa biolink của bạn với màu sắc và nhận diện thương hiệu tùy chỉnh.",
        sec_thered_thired_line:
          "Trải nghiệm dễ dàng hơn với nhiều thành phần sẵn sàng sử dụng.",
        sec_thered_four_line: "Thêm Nhận diện thương hiệu và Tối ưu hóa SEO.",
      },
      pricing_section: {
        subscription: "Đăng ký",
        choose_a: "Chọn một",
        plan: "kế hoạch",
        that_works_for_you: "thích hợp với bạn",
        monthly: "Hàng tháng",
        annual: "Hàng năm",
        what_included: "Bao gồm gì",
        unlimited_biolink_pages: "Số lượng trang Biolink không giới hạn",
        unlimited_biolink_blocks: "Số lượng khối Biolink không giới hạn",
        bio_pages: "25 Trang Biolink",
        seo_feature: "Tính năng SEO",
        brandings: "Nhận diện thương hiệu",
        customer_support: "Hỗ trợ khách hàng 24/7",
      },
      create_page_section: {
        bilbio: "bilbio",
        start_creating_your_exclusive: "Bắt đầu tạo nên sự độc đáo của bạn",
        start_creating_your_exclusive_bilbio:
          "Bắt đầu tạo nên sự độc đáo của bạn với bilbio",
        biolink_url: "URL biolink",
        now: "NGAY BÂY GIỜ",
      },
    },
    about: {
      description_text:
        "Lorem Ipsum chỉ là văn bản giả mạo của ngành in và xuất bản.Lorem Ipsum đã trở thành văn bản giả mạo tiêu chuẩn của ngành từ thế kỷ 15, khi một máy in không rõ người đã lấy một dàn chữ và trộn nó để tạo nên một cuốn sách mẫu. Nó đã tồn tại không chỉ năm thế kỷ, mà còn nhảy vào xu hướng in điện tử, vẫn giữ nguyên bản. Nó trở nên phổ biến vào những năm 1960 với việc phát hành các tờ Letraset chứa đoạn văn Lorem Ipsum.",
      description_text_mobile:
        "Lorem Ipsum chỉ là văn bản giả mạo của ngành in và xuất bản.Lorem Ipsum đã trở thành văn bản giả mạo tiêu chuẩn của ngành từ thế kỷ 15, khi một máy in không rõ người đã lấy một dàn chữ.",
      team: "Đội ngũ",
      meet_our_amazing: "Gặp gỡ đội ngũ Tuyệt vời của chúng tôi",
      view_all: "Xem tất cả",
      get_in_touch: "LIÊN HỆ",
    },
    contact: {
      fill_up_your_contact: "Điền thông tin liên hệ của bạn",
      information_and_our_team: "thông tin và đội ngũ của chúng tôi",
      will_get_back_to_you: "sẽ liên hệ lại với bạn.",
      enter_first_name: "Nhập Tên",
      enter_last_name: "Nhập Họ",
      enter_phone_number: "Nhập Số điện thoại",
      enter_email: "Nhập Địa chỉ Email",
      enter_message_here: "Nhập tin nhắn của bạn ở đây",
      last_name: "Họ",
      phone_number: "Số điện thoại",
      enter_valid_number: "Nhập số hợp lệ",
      message: "Tin nhắn",
      last_name_required: "Yêu cầu Họ",
      phone_number_required: "Yêu cầu Số điện thoại",
      the_email_should_have_less_then_characters:
        "Email phải có ít hơn 50 ký tự",
      message_required: "Yêu cầu nhập nội dung tin nhắn",
    },
    pricing: {
      simple_plans_for: "Kế hoạch đơn giản cho",
      everyone: "mọi người",
      have_a_coupon: "Có phiếu giảm giá?",
      choose_your_plan_get_amazing_discounts_cancel_anytime:
        "Chọn kế hoạch của bạn. Nhận ưu đãi tuyệt vời. Hủy bất kỳ lúc nào.",
      free_plan: "Kế hoạch miễn phí",
      premium_plan_paid: "Kế hoạch Premium (Trả phí)",
    },
    privacy_policy: {
      lorem_ipsum_is_simply_dummy_text_of_the_printing:
        "Lorem Ipsum chỉ là văn bản giả mạo của ngành in và xuất bản.",
      lorem_ipsum_has_been_the_industry_standard_dummy_text:
        "Lorem Ipsum đã trở thành văn bản giả mạo tiêu chuẩn của ngành.",
      what_is_lorem_ipsum: "Lorem Ipsum là gì?",
      first_para:
        "Lorem Ipsum chỉ là văn bản giả mạo của ngành in và xuất bản. Lorem Ipsum đã trở thành văn bản giả mạo tiêu chuẩn của ngành từ thế kỷ 15, khi một máy in không rõ người đã lấy một dàn chữ và trộn nó để tạo nên một cuốn sách mẫu. Nó đã tồn tại không chỉ năm thế kỷ, mà còn nhảy vào xu hướng in điện tử, vẫn giữ nguyên bản. Nó trở nên phổ biến vào những năm 1960 với việc phát hành các tờ Letraset chứa đoạn văn Lorem Ipsum.",
      second_para:
        "Lorem Ipsum chỉ là văn bản giả mạo của ngành in và xuất bản. Lorem Ipsum đã trở thành văn bản giả mạo tiêu chuẩn của ngành từ thế kỷ 15, khi một máy in không rõ người đã lấy một dàn chữ và trộn nó để tạo nên một cuốn sách mẫu. Nó đã tồn tại không chỉ năm thế kỷ, mà còn nhảy vào xu hướng in điện tử, vẫn giữ nguyên bản. Nó trở nên phổ biến vào những năm 1960 với việc phát hành các tờ Letraset chứa đoạn văn Lorem Ipsum",
      li_one:
        "Ngược lại với quan điểm phổ biến, Lorem Ipsum không chỉ là văn bản ngẫu nhiên. Nó có nguồn gốc từ một đoạn văn văn học Latin cổ điển từ năm 45 TCN, khiến nó trở thành hơn 2000 năm tuổi.",
      li_two:
        "Richard McClintock, giáo sư Latin tại Hampden-Sydney College ở Virginia, tra cứu một trong những từ Latin ít biết đến hơn, consectetur, từ một đoạn văn Lorem Ipsum, và qua các nguồn trích của từ trong văn học cổ điển, ông phát hiện nguồn gốc không thể chối cãi.",
      li_three:
        'Lorem Ipsum xuất phát từ các phần 1.10.32 và 1.10.33 của "de Finibus Bonorum et Malorum" (Đỉnh điểm của Thiện và Ác) của Cicero, được viết vào năm 45 TCN.',
      li_four:
        'Cuốn sách này là một luận thuyết về lý thuyết đạo đức, rất phổ biến trong thời kỳ Phục hưng. Dòng đầu tiên của Lorem Ipsum, "Lorem ipsum dolor sit amet..", xuất phát từ một dòng trong phần 1.10.32.',
      why_do_we_use_it: "Chúng ta tại sao sử dụng nó?",
      last_para:
        "Đó là một sự thật đã được thiết lập rằng người đọc sẽ bị xao lạc bởi nội dung có thể đọc được của một trang khi nhìn vào bố cục của nó. Điểm của việc sử dụng Lorem Ipsum là nó có một phân phối chữ cái tương đối bình thường, so với việc sử dụng 'Nội dung ở đây, nội dung ở đây', làm cho nó trông giống tiếng Anh có thể đọc được. Nhiều gói phần mềm xuất bản và biên tập trang web ngày nay sử dụng Lorem Ipsum như là văn bản mẫu mặc định của họ, và một tìm kiếm về 'lorem ipsum' sẽ phát hiện ra nhiều trang web vẫn còn ở trong giai đoạn non trẻ. Nhiều phiên bản đã phát triển qua các năm, đôi khi là do tai nạn, đôi khi có ý định (chèn hài hước và những thứ tương tự).",
    },
  },
  cms: {
    appearance: "Giao diện",
    location: "Vị trí",
    profile: "Hồ sơ",
    seo: "Seo",
    page: "Trang",
    account: "Tài khoản",
    security: "Bảo mật",
    billings: "Thanh toán",
    custom_image: "Hình ảnh tùy chỉnh",
    maximum: "tối đa",
    choose_another: "CHỌN KHÁC",
    select_font: "Chọn Font",
    rounded_corners: "Góc bo tròn",
    circle: "Hình tròn",
    full_rounded_corners: "Góc bo tròn đầy đủ",
    straight_corners: "Góc thẳng",
    outline: "Đường nét",
    button_background_color: "Màu nền nút",
    timer_digit_color: "Màu số đếm",
    timer_background_color: "Màu nền đếm ngược",
    button_font_color: "Màu chữ nút",
    outline_style: "Kiểu đường nét",
    outline_width: "Độ dày đường nét",
    corners: "Các góc",
    insert_graph_image: "CHÈN HÌNH ẢNH ĐỒ THỊ",
    enble_block_search_engine_indexing: "Bật chặn đánh index từ máy tìm kiếm",
    page_title_required: "Yêu cầu tiêu đề trang",
    meta_description_required: "Yêu cầu mô tả meta",
    branding_url_required: "Yêu cầu URL nhận diện thương hiệu",
    enter_title: "Nhập tiêu đề",
    enter_url: "Nhập URL",
    enter_meta_description: "Nhập mô tả meta",
    enter_page_title: "Nhập tiêu đề trang",
    enter_alt_text: "Nhập văn bản thay thế (ALT)",
    hours: "Giờ",
    minutes: "Phút",
    seconds: "Giây",
    scan_qr_code: "Quét mã QR",
    cancel: "Hủy",
    you_sure_want_to_logout: "Bạn có chắc chắn muốn đăng xuất không?",
    previous: "Trước",
    next: "Tiếp",
  },
  appearance: {
    background_cap: "NỀN",
    background: "Nền",
    favicon_cap: "FAVICON",
    favicon: "Favicon",
    fonts_cap: "FONTS",
    fonts: "Fonts",
    seo_cap: "SEO",
    seo: "Seo",
    avatar_cap: "AVATAR",
    avatar: "Avatar",
    link_cap: "LIÊN KẾT",
    link: "Liên kết",
    branding_cap: "NHẬN DIỆN THƯƠNG HIỆU",
    branding: "Nhận diện thương hiệu",
  },
  contact: {
    name_required: "Tên là bắt buộc",
    only_alphabets: "Chỉ chữ cái được phép cho trường này",
    more_characters: "Tên không được quá 20 ký tự.",
    valid: "Email phải là một địa chỉ hợp lệ",
    subject: "Chủ đề là bắt buộc",
    subject_max: "Chủ đề không được quá 30 ký tự.",
    message: "Nội dung là bắt buộc",
    message_min: "Nội dung tối thiểu phải có 40 ký tự.",
    message_max: "Nội dung không được quá 250 ký tự.",
  },
  descriptions: {
    shorten_urls:
      "Tận dụng các nền tảng trực tuyến khác nhau để tương tác với những người có cùng ý kiến, tăng sự chú ý và xây dựng một hiện diện kỹ thuật số cho sự sáng tạo của bạn, tất cả đều từ một liên kết sinh học của bạn.",
    fully_featured:
      "Hệ thống tạo mã QR đầy đủ tính năng với các mẫu dễ sử dụng.",
    update_checkout: "Cập nhật & tiếp tục thanh toán Vàng",
    plans_management: "Quản lý Kế hoạch",
    create_plan: "Tạo Kế hoạch",
    no_account: "Chưa có tài khoản?",
    leave_empty: "Để trống để tạo một liên kết ngẫu nhiên.",
    scan_qr:
      "Nếu bạn muốn kích hoạt xác minh hai yếu tố, quét Mã QR hoặc nhập khóa bí mật vào Ứng dụng Google Authenticator và nhập OTP",
    skip: "Hoặc bỏ qua",
    copy_Qr: "Sao chép khóa bí mật, nó là bảo mật",
    scanned: "Kiểm tra email hoặc Google Authenticator của bạn để có mã.",
    do_everything: "Làm tất cả",
    with_one: "với một",
    platform: "nền tảng",
    get_started: "BẮT ĐẦU",
    create_own:
      "Tạo trang liên kết sinh học của bạn với tính năng độc đáo và có thể tùy chỉnh cao một cách dễ dàng.",
    custom_colors: "Màu sắc và thương hiệu tùy chỉnh",
    ready_to_use: "Nhiều thành phần sẵn có để sử dụng",
    protection: "Bảo vệ mật khẩu, cảnh báo nội dung nhạy cảm",
    seo_setting: "Thiết lập SEO",
    shortened_links: "Liên kết được rút gọn",
    service:
      "Có! Bạn có thể sử dụng dịch vụ của chúng tôi như một công cụ rút gọn cũng.",
    demographic: "Quốc gia, thiết bị & đối tượng ngôn ngữ",
    scheduling: "Lên lịch & giới hạn hết hạn",
    ab_rotation: "Quay A/B",
    password: "Bảo vệ mật khẩu, cảnh báo nội dung nhạy cảm",
    built_in: "Phân tích tích hợp",
    generate_links:
      "Tạo liên kết động đến tệp và tận hưởng theo dõi, bảo vệ, pixel & tính năng hết hạn.",
    generate_vcard:
      "Tạo liên kết vcard động đến thẻ tải về liên hệ của bạn và tận hưởng theo dõi, bảo vệ, pixel & tính năng hết hạn.",
    day_by:
      "Cho phân tích hàng ngày, giới thiệu, quốc gia, hệ điều hành, ngôn ngữ và nhiều hơn nữa.",
    connect:
      "Kết nối tên miền riêng của bạn hoặc sử dụng các tên miền được xác định trước của chúng tôi.",
    easiest_way: "Cách dễ nhất để phân loại tài nguyên quản lý của bạn.",
    offering:
      "Chúng tôi cũng mang đến cho bạn một bộ công cụ web hữu ích với 35 công cụ như một phần thưởng.",
    choose_yourself: "Chọn và nhận đúng những gì bạn cần.",
    feel_free: "Đừng ngần ngại liên hệ với chúng tôi",
    enter_message: "Nhập thông điệp của bạn ở đây.",
    add_multiple_images: "Thêm Nhiều Hình Ảnh",
    add_link: "Thêm nút Liên kết",
    add_new: "Thêm một khối mới",
    add_heading: "Thêm tiêu đề",
    add_avatar: "Thêm hình đại diện",
    add_social: "Thêm liên kết xã hội",
    choose_custom_plan: "Bắt đầu Kế hoạch Vàng",
    almost_there: "Bạn chỉ còn một bước nữa, không có ràng buộc nào.",
    trial_start: "Bắt đầu Thử nghiệm 7 Ngày của tôi",
    skip_trial: "Bỏ qua Thử nghiệm",
    trial_info:
      "Bằng cách tiếp tục với đơn đặt hàng của bạn, bạn xác nhận rằng bạn đã đọc, hiểu & đồng ý với  của trang web.",
    terms: "Điều khoản và Điều kiện",
    add_image: "Thêm Hình Ảnh",
    img_description: "Mô tả hình ảnh cho mục đích truy cập và SEO.",
    add_youtube: "Thêm video YouTube",
    paste_video_url:
      "Dán URL video YouTube của bạn và chúng tôi sẽ hiển thị nó như một video trên hồ sơ của bạn.",
    add_tiktok: "Thêm video TikTok",
    tiktok_url: "URL Video TikTok",
    valid_email: "Email phải là địa chỉ email hợp lệ",
    distination_Url: "distination_url",
    email_required: "Yêu cầu Email",
    password_required: "Yêu cầu Mật khẩu",
    name_required: "Yêu cầu Tên",
    user_name_required: "Yêu cầu Tên người dùng",
    firstName_required: "Yêu cầu Tên đầu tiên",
    firstName_must_alphabets: "Tên đầu tiên phải chứa chữ cái.",
    lastName_must_alphabets: "Họ phải chỉ chứa chữ cái.",
    enter_email:
      "Vui lòng nhập địa chỉ email liên kết với tài khoản của bạn và chúng tôi sẽ gửi email cho bạn một liên kết để đặt lại mật khẩu của bạn.",
    already_account: "Đã có tài khoản?",
    paste_tiktok: "Chia sẻ URL video TikTok của bạn",

    drag_drop: "Kéo & Thả để Sắp xếp lại",
    can_confirm: "Tôi xác nhận rằng tôi đã đọc và hiểu",
    of_site: "của trang web.",
    confirm_password: "Xác nhận Mật khẩu mới",
    confirm_new: "Xác nhận mật khẩu là bắt buộc",
    field_required: "Yêu cầu Trường",
    add_instagram: "Thêm bài đăng Instagram",
    entered_url: "URL bạn đã nhập không hợp lệ để nhúng",
    least_characters: "Mật khẩu phải có ít nhất 6 ký tự",
    must_match: "Mật khẩu phải khớp",
    check_email: "Vui lòng kiểm tra email của bạn!",
    sent_code:
      "Chúng tôi đã gửi một mã xác nhận 6 chữ số đến acb@domain, vui lòng nhập mã vào ô dưới đây để xác minh email của bạn.",
    no_code: "Không có mã?",
    code_required: "Yêu cầu Mã",
    checking_email: "Kiểm tra Email người dùng",
    monthly_payment: "Thanh toán hàng tháng",
    golden_plan: "Kế hoạch Vàng",
    plan_detail:
      "Bạn chỉ còn một bước nữa, hãy hoàn thành biểu mẫu dưới đây và thanh toán.",
    payment_frequency: "Tần suất thanh toán",
    annual_payments: "Thanh toán hàng năm",
    lifetime_deal: "Gói trọn đời",
    payment_method: "Phương thức thanh toán",
    payment_method_stripe: "Thanh toán bằng Stripe",
    type_payment: "Loại thanh toán",
    stripe: "Stripe",
    one_payment: "Thanh toán một lần",
    recurring_payment: "Thanh toán định kỳ",
    order_summary: "Tóm tắt đơn hàng",
    plan: "Kế hoạch",
    golden: "Vàng",
    frequency: "Tần suất",
    monthly: "Hàng tháng",
    type: "Loại",
    one_time: "Một lần",
    paid_with: "Thanh toán bằng",
    pay_pal: "PayPal",
    price: "Giá",
    code_redeemable: "Tôi có một mã giảm giá/có thể đổi được",
    code: "Mã",
    total: "Tổng cộng",
    checkout: "Thanh toán",
    day: "Mỗi 30 ngày",
    billing: "Thanh toán",
    choosen_plan: "Kế hoạch đã chọn",
    home: "Trang chủ",
    what_get: "Bạn sẽ nhận được gì",
    one_product: "Một sản phẩm cuối cùng",
    month_update: "12 tháng cập nhật",
    month_support: "6 tháng hỗ trợ",
    bio_pages: "25 Trang Liên kết Sinh học",
    bio_block: "10 Khối Liên kết Sinh học",
    all_block: "Tất cả Khối Liên kết Sinh học",
    short_link: "250 Liên kết Rút gọn",
    file_link: "2 Liên kết Tệp",
    vcard_link: "2 Liên kết Vcard",
    qr_code: "5 Mã QR",
    proj: "50 Dự án",
    pixel: "5 Pixels",
    custom_domain: "Tên miền Tùy chỉnh",
    day_stat: "Du trữ thống kê 365 ngày",
    global_domain: "Tên miền Toàn cầu Bổ sung",
    back_half: "Bán tùy chỉnh",
    deep_lnk: "Liên kết sâu",
    removable_brand: "Thương hiệu có thể di chuyển",
    custom_back: "Nền Tùy chỉnh",
    custom_col: "Màu sắc Tùy chỉnh",
    defollow: "Liên kết Dofollow",
    leap_link: "Liên kết nhảy",
    seo_feature: "Tính năng SEO",
    extra_font: "Fonts Extra",
    add_tweet: "Thêm Tweet",
    custome_css: "CSS Tùy chỉnh",
    custom_js: "JS Tùy chỉnh",
    no_ad: "Không có quảng cáo",
    api_access: "Truy cập API",
    fill: "Điền vào thông tin thanh toán của bạn",
    handling:
      "Chúng tôi yêu cầu thông tin thanh toán của bạn để tạo hóa đơn đúng & để xử lý thuế, chỉ cung cấp chi tiết thanh toán hợp lệ.",
    user_manag: "Quản lý Người dùng",
    user_logs: "Nhật ký Người dùng",
    user_creat: "Tạo Người dùng",
    set_2fa: "Thiết lập Xác minh Hai yếu tố",
    user: "Người dùng",
    showout_result: "Hiển thị Kết quả",
    status: "Trạng thái",
    applied_codes: "Mã đã áp dụng",
    applied_taxes: "Thuế đã áp dụng",
    detail: "Chi tiết",
    bulk_actions: "Hành động hàng loạt",
    hidden_demo: "Ẩn trong bản demo",
    cant_undone: "Không thể hoàn tác.",
    login_thisuser: "Đăng nhập với tư cách người dùng này",
    loginmodal_detail1:
      "Bằng cách đăng nhập với một người dùng khác, bạn sẽ đăng xuất khỏi",
    loginmodal_detail2:
      "tài khoản hiện tại và hoàn toàn đăng nhập vào người dùng này.",
    show_result: "Hiển thị 1-12 trong số 12 kết quả.",
    total_sales: "Tổng doanh số",
    visitors: "Khách truy cập",
    page_views: "Lượt xem trang",
    paste_instagram_url: "Dán URL của bài đăng Instagram",
    delete_block_des:
      "Tất cả dữ liệu liên quan đến khối biolink sẽ bị xóa hoàn toàn. Hành động này không thể hoàn tác.",
    duplicate_block_des:
      "Dễ dàng nhân đôi nguồn tài nguyên này chỉ với một cú nhấp chuột.",
    delete_block: "Xóa khối",
    duplicate_block: "Nhân bản khối",
    total_amount: "Tổng số tiền",
    admin_privileges:
      "Người quản trị sẽ có những đặc quyền giống như bạn, hãy cẩn thận!",
    change_passDetail:
      "Để trống nếu bạn không muốn thay đổi mật khẩu của người dùng!",
    new_pass: "Mật khẩu mới",
    repeat_pass: "Lặp lại Mật khẩu",
    block_search: "Chặn Chỉ mục Công cụ Tìm kiếm",
    block_biolink:
      "Chặn trang biolink của bạn được lập chỉ mục bởi các công cụ tìm kiếm.",
    change_page:
      "Thay đổi hoàn toàn tiêu đề trang thành một tiêu đề tùy chỉnh mà bạn đang đặt ở đây.",
    custom_meta:
      "Thiết lập mô tả meta tùy chỉnh cho trang biolink của bạn để xếp hạng tốt hơn trên các công cụ tìm kiếm.",
  },
  admin: {
    welcome: "Chào mừng trở lại",
    biolink_pages: "Trang Biolink",
    pageviews_tracked: "Lượt xem trang được theo dõi",
  },

  label: {
    view_user: "Xem Người dùng",
    privileges: "Đặc quyền",
    timezone: "Múi giờ",
    Factor_authentication: "Xác minh Hai yếu tố",
    Factor_authentication_2: "Xác minh Hai yếu tố",
    Anti_code: "Mã chống lừa đảo",
    active: "Hoạt động",
    english: "Tiếng Anh",
    no: "Không",
    api_key: "Khóa API",
    total_logins: "Tổng số lần đăng nhập",
    last_useragent: "Trình duyệt cuối cùng",
    last_active: "Hoạt động lần cuối",
    country: "Quốc gia",
    direct_signup: "Đăng ký trực tiếp",
    source: "Nguồn",
    trial_done: "Dùng thử đã kết thúc",
    last_subid: "ID đăng ký cuối cùng",
    last_payamount: "Số tiền thanh toán cuối cùng",
    last_payprocessor: "Bộ xử lý thanh toán cuối cùng",
    plan_expdate: "Ngày hết hạn kế hoạch",
    free: "Miễn phí",
    disabled: "Vô hiệu hóa",
    hidden: "Ẩn",
    arabic: "Tiếng Ả Rập",
    main_language: " Ngôn ngữ chính",
    add_tweet: "Thêm Tweet",
    update: "Cập nhật",
    change_password: "Đổi mật khẩu",
    enable_stripepay: "Kích hoạt thanh toán bằng Stripe",
    publishable_key: "Khóa có thể xuất bản",
    secret_key: "Khóa bí mật",
    webhook_secret: "Mã bí mật Webhook",
    webhook: "Webhook",
    more_detail: " để biết thêm chi tiết về một số cấu hình cụ thể có sẵn.",
    read_the: "Đọc",
    documentation: "Tài liệu",
  },
  addBlock: {
    essentials: "CƠ BẢN",
    text: "VĂN BẢN",
    media: "PHƯƠNG TIỆN",
    miscellaneous: "VARIETY",
    addBlocks: "Thêm Khối",
    viewBlock: "Xem Khối",
    paymentDetails: "Chi Tiết Thanh Toán",
    renewal: "Gia Hạn",
    inclusive_tax: "Thuế Bao Gồm",
    apply: "ÁP DỤNG",
    plan: "Kế Hoạch",
    enter_coupon_code: "Nhập Mã Giảm Giá",
    set_up_your: "THIẾT LẬP CỦA BẠN",
    credit_debit_card: "THẺ TÍN DỤNG/THẺ GHI NỢ",
    card_number: "Số Thẻ",
    card_number_is_required: "Yêu cầu Số Thẻ",
    please_enter_valid_card_number: "Vui lòng Nhập Số Thẻ hợp lệ",
    please_enter_valid_cvv_number: "Vui lòng Nhập Mã CVV hợp lệ",
    expiry_date_is_required: "Yêu cầu Ngày Hết Hạn",
    expiry_date: "Ngày Hết Hạn",
    enter_valid_month: "Nhập Tháng Hợp Lệ",
    enter_valid_year: "Nhập Năm Hợp Lệ",
    expiry_date_valid_month_year: "Nhập Ngày Hết Hạn Hợp Lệ",
    cvv_is_required: "Yêu cầu Mã CVV",
    invalid_characters_in_name: "Ký tự không hợp lệ trong tên",
    change: "THAY ĐỔI",
    renew_plan_automatically:
      "Gia hạn kế hoạch tự động vào cuối mỗi tháng. Hủy bất kỳ lúc nào.",
    make_payment: "THANH TOÁN",
    subscribe_start_customizing: "Đăng ký và bắt đầu tùy chỉnh",
    your_biolink_now: "Biolink CỦA BẠN NGAY!",
    year: "Năm",
    month: "Tháng",
    annual: "Hàng năm",
    off: "Giảm",
    auto: "Tự động",
    payment_successful: "Thanh toán thành công",
    enjoy: "TẬN HƯỞNG",
    using_premium_and_continue: "sử dụng Premium và tiếp tục tạo",
    exclusive_biolinks: "Biolinks độc quyền",
    page: "Trang",
    account: "Tài khoản",
    account_: "TÀI KHOẢN",
    security: "Bảo mật",
    billings: "Thanh toán",
    setting: "Cài đặt",
    page_name: "TÊN TRANG",
    update_your_page_name:
      "Cập nhật tên trang của bạn để tạo danh tính duy nhất.",
    save_changes: "LƯU THAY ĐỔI",
    page_name_cannot: "Tên trang không thể chứa ký tự đặc biệt",
    remove: "LOẠI BỎ",
    personal_details: "Chi Tiết Cá Nhân",
    first_name_must_be_valid: "Tên phải là tên hợp lệ",
    first_name_must_be_20_characters: "Tên phải có tối đa 20 ký tự",
    email_should_be_50_characters: "Email phải có tối đa 50 ký tự",
    email_address_must_be_valid: "Địa chỉ email phải là địa chỉ hợp lệ",
    upload: "TẢI LÊN",
    choose_account_type: "Chọn Loại Tài khoản",
    enter_country: "Nhập Quốc gia",
    state_region: "Bang/Quận",
    enter_state_region: "Nhập Bang/Quận",
    enter_city: "Nhập Thành phố",
    zip_code: "Mã Zip",
    enter_zip_code: "Nhập Mã Zip",
    account_type_required: "Yêu cầu Loại Tài khoản",
    country_required: "Yêu cầu Quốc gia",
    State_region_required: "Yêu cầu Bang/Quận",
    city_required: "Yêu cầu Thành phố",
    zip_required: "Yêu cầu Zip",
    image_smaller_than_3MB: "Hình ảnh phải nhỏ hơn 3MB",
    please_select_picture: "Vui lòng chọn một bức ảnh",
    image_size_should_be_3mb:
      "Kích thước hình ảnh không được vượt quá 3MB. Các tệp .jpeg và .png được phép.",
    security_: "BẢO MẬT",
    enter_password_twice:
      "Nhập mật khẩu mới hai lần để thay đổi mật khẩu của bạn",
    new_password: "Mật khẩu mới",
    password_must_8_characters: "Mật khẩu phải chứa ít nhất 8 ký tự",
    including_uppercase_letter:
      "bao gồm 1 chữ in hoa, 1 chữ thường, 1 ký tự đặc biệt và 1 giá trị số",
    enter_new_password: "Nhập Mật khẩu Mới",
    confirm_password: "Xác nhận Mật khẩu",
    password_confirmation_required: "Yêu cầu Xác nhận Mật khẩu",
    passwords_not_match: "Mật khẩu không khớp",
    enter_confirm_password: "Nhập Xác nhận Mật khẩu",
    factor_authentication_description:
      "Nếu bạn muốn kích hoạt xác minh hai yếu tố, quét Mã QR hoặc nhập khóa bí mật trong Ứng dụng Xác minh Google và nhập OTP",
    choose_plan_description: "Chọn một kế hoạch phù hợp với yêu cầu của bạn",
    billing_history: "LỊCH SỬ THANH TOÁN",
    date_joined: "Ngày tham gia",
    last_activity: "Hoạt động cuối cùng",
    annually: "Hàng năm",
  },
  enter: "Nhập",
  media: "Phương tiện",
  link_URL_must_start: "Liên kết URL phải bắt đầu bằng http:// hoặc https://",
  link_icon_required: "Yêu cầu biểu tượng liên kết",
  link_url_required: " Yêu cầu URL liên kết",
  link_is_required: "Yêu cầu Tiêu đề Liên kết",
  add_icon: "THÊM BIỂU TƯỢNG",
  enter_link: "Nhập liên kết",
  enter_link_title: "Nhập tiêu đề liên kết",
  custom_link: "LIÊN KẾT TÙY CHỈNH",
  add_image_grid: "Thêm Hình Ảnh Lưới",
  header_required: "Yêu cầu Tiêu đề",
  enter_header: "Nhập Tiêu đề",
  header_size: "Kích thước tiêu đề",
  header_: "Tiêu đề",
  question_required: "Yêu cầu Câu hỏi",
  answer_required: "Yêu cầu Trả lời",
  enter_question: "Nhập Câu hỏi",
  enter_answer: "Nhập Trả lời",
  choose_time: "Chọn Thời gian",
  choose_date: "Chọn Ngày",
  drop_your_img: "Kéo ảnh của bạn vào đây hoặc",
  browse_image: "DUYỆT ẢNH",
  save: "Lưu",
  components: "Thành phần",
  payments: "Thanh toán",
  terms_here: "Các điều khoản dịch vụ của bạn ở đây",
  bold: "In đậm",
  user_id: "ID Người dùng",
  italic: "In nghiêng",
  underline: "Gạch chân",
  changelog_config:
    "Hãy chắc chắn re-cấu hình cài đặt kế hoạch của bạn cho cấu hình mới thêm vào tên miền",
  initial_release: "Phát hành ban đầu",
  changelog_detail:
    "Tất cả cập nhật cho Bil Bio sẽ được liệt kê ở đây. Hệ thống phiên bản Bil Bio dựa trên hệ thống MAJOR.MINOR.PATCH",
  get_support: "Nhận Hỗ trợ",
  support_is: "Hỗ trợ là ",
  only: "chỉ",
  done_codecanyon: "qua",
  email_form: "biểu mẫu email",
  comments: "bình luận",
  section: "phần",
  changelog: "Changelog",
  edit_home: "Chỉnh sửa Trang chủ",
  home_settings: "Cài đặt Trang chủ",
  docs: "Tài liệu",
  read_documentation: "Đọc Tài liệu",
  read_changelog: "Đọc Changelog",
  latest_users: "Người dùng Mới Nhất",
  page_views: "Lượt xem trang",
  biolinks_pages: "Trang Biolinks",
  authenticate: "Xác thực",
  auth_type: "Loại Xác thực ",
  time_based: "Dựa trên Thời gian ",
  secret_key: "Khóa bí mật",
  availabe_plan: "Kế hoạch sẽ có sẵn trong bao lâu",
  code_usage: "Mã có thể sử dụng bao nhiêu lần",
  percent_disc: "Giảm giá theo phần trăm",
  fix_discount: "Giảm giá cố định",
  discount_amount: "Số tiền giảm giá",
  percent_amount: "Số tiền phần trăm",
  duration: "Thời lượng",
  once: "một lần",
  forever: "mãi mãi",
  repeating: "lặp lại",
  number_ofmonths: "Số tháng",
  months: "tháng",
  currency: "Tiền tệ",
  redeemable: "Có thể đổi",
  install_product: "Làm thế nào để cài đặt sản phẩm?",
  update_product: "Làm thế nào để cập nhật sản phẩm? ",
  customize_product: "Làm thế nào để tùy chỉnh sản phẩm?",
  meta_description: "Mô tả Meta",
  title: "Tiêu đề",
  statistics: "Thống kê",
  opengraph_image: "Ảnh Opengraph",
  page_title: "Tiêu đề Trang",
  countdown: "Đếm ngược",
  personal: "Cá nhân",
  business: "Doanh nghiệp",
  city: "Thành phố",
  country: "Quốc gia",
  province: "Tỉnh",
  zip: "Zip",
  resend_code: "Gửi lại Mã",
  yes: "Có",
  choose_plan: "Chọn Kế hoạch",
  choose_plan_cap: "CHỌN KẾ HOẠCH",
  home: "Trang chủ",
  social: "Mạng xã hội",
  whatYouWillGet: "Những gì bạn sẽ nhận được",
  and: "và",
  links_statistics: "Thống kê Liên kết",
  oftheSite: "của trang web",
  link: "Liên kết",
  link_cap: "LIÊN KẾT",
  telephone: "Điện thoại",
  register: "Đăng ký",
  facebook: "Facebook",
  google: "Google",
  tracking_pixels: "Pixel theo dõi",
  tool: "Công cụ",
  block: "Khối",
  instagram: "Instagram",
  twitter: "Twitter",
  username: "Tên đăng nhập",
  add: "Thêm",
  add_cap: "THÊM",
  short_url: "URL Ngắn",
  customization: "Tùy chỉnh",
  channel: "Kênh",
  branding: "Thương hiệu",
  fonts: "Fonts",
  submit: "Gửi",
  tracked_reviews: "Lượt xem theo dõi",
  delete: "Xóa",
  duplicate: "Nhân bản",
  monochrome: "Đơn sắc",
  gradient: "Độ dốc",
  custom: "Tùy chỉnh",
  themes: "Chủ đề",
  background: "Nền",
  simple_gradients: "Độ dốc đơn giản",
  abstract_gradients: "Độ dốc trừu tượng",
  custom_color: "Màu tùy chỉnh",
  faq: "FAQ",
  color: "Màu sắc",
  colors: "Màu sắc",
  custom_image_video: "Ảnh/Video Tùy chỉnh",
  favicon: "Biểu tượng trang",
  share: "Chia sẻ",
  image_alt: "Chú thích ảnh",
  maximum: ".png, .gif, .ico, được phép. Tối đa 2 MB.",
  display: "Hiển thị",
  total_earned: "Tổng Thu nhập",
  name: "Tên",
  Unique_user_name: "Tên người dùng duy nhất",
  firstName: "Tên Đầu tiên",
  text_color: "Màu văn bản",
  default_branding: "Để trống để sử dụng thương hiệu mặc định của trang.",
  size: "Kích thước",
  shape: "Hình dạng",
  instagram_url: "URL Bài đăng Instagram",
  border_radius: "Bán kính biên giới",
  youtube_url: "URL Video YouTube",
  total: "Tổng",
  biolinks: "Biolinks",
  biolink: "Biolink",
  files: "Tệp",
  file: "Tệp",
  biolink_blocks: "Các khối Biolink",
  card: "Thẻ",
  destination_url: "URL Đích",
  codes: "Mã",
  domains: "Tên miền",
  create: "Tạo Mã",
  links: "Liên kết",
  copyright: "Bản quyền",
  terms_of_service: "Điều khoản Dịch vụ",
  views: "lượt xem",
  privacy_policy: "Chính sách Bảo mật",
  overview: "Tổng quan",
  needed_docs:
    "Trong trang này, bạn có thể tìm thấy tài liệu cần thiết để cài đặt và cấu hình đầy đủ sản phẩm.",
  product_installation:
    "Quy trình cài đặt sản phẩm là trực tiếp và không đòi hỏi bất kỳ công việc đặc biệt nào / nhiệm vụ đặc biệt. Kiến thức tối thiểu về cách làm việc với cơ sở dữ liệu và quản lý tệp trên máy chủ là cần thiết.",
  policy_here: "Chính sách Quyền riêng tư của bạn ở đây",
  requirements: "Yêu cầu",
  meet_req:
    "Vui lòng đảm bảo rằng máy chủ của bạn đáp ứng các yêu cầu sau trước khi cài đặt hoặc mua sản phẩm.",
  created_on: "Được tạo vào",
  extensions: "Phần mở rộng",
  database: "Cơ sở dữ liệu",
  server: "Máy chủ",
  other_extentions:
    "Lưu ý rằng, các phần mở rộng khác ngoài những cái được đề cập ở đây có thể được yêu cầu, vì những yêu cầu này giả định rằng bạn đang chạy trên một máy chủ tốt, cập nhật và nên có các phần mở rộng cơ bản cần thiết đã hoạt động.",
  find_me:
    "Tôi xây dựng phần mềm chất lượng cao, sẵn sàng sử dụng và giá cả phải chăng. Đây là nơi bạn có thể tìm thấy tôi:",
  december: "Tháng 12",
  twitter_bilBio: "Twitter @BilBio",
  official_website: "Trang web chính thức",
  who_are_we: "Chúng tôi là ai?",
  all_rights_reserved: "Mọi quyền được bảo lưu",
  export_to: "Xuất sang",
  filter: "Bộ lọc",
  search: "Tìm kiếm",
  search_by: "Tìm kiếm theo",
  status: "Trạng thái",
  project: "Dự án",
  type: "Loại",
  order_type: "Loại đặt hàng",
  results_per_page: "Kết quả mỗi trang",
  your_custom_alias: "biệt danh-tùy-chỉnh-của-bạn",
  mode: "Chế độ",
  contrast: "Tương phản",
  direction: "Hướng",
  layout: "Bố cục",
  presets: "Bộ ghi sẵn",
  stretch: "Kéo ra",
  fullscreen: "Toàn màn hình",
  exit: "Thoát",
  pricing_plans: "Kế hoạch giá",
  monthly: "Hàng tháng",
  annual: "Hàng năm",
  life_time: "Trọn đời",
  address: "Địa chỉ",
  phone: "Điện thoại",
  send_message: "GỬI THÔNG BÁO",
  email: "Email",
  subject: "Chủ đề",
  heading: "Tiêu đề",
  text_editor: "Trình soạn thảo văn bản",
  avatar: "Ảnh đại diện",
  socials: "Mạng xã hội",
  linkedin: "LinkedIn",
  snapchat: "SnapChat",
  twitch: "Twitch",
  spotify: "Spotify",
  image: "Ảnh",
  pinterest: "Pinterest",
  youtube: "YouTube",
  tiktok: "TikTok",
  about_section: "Cài đặt Phần Giới thiệu",
  contact_settings: "Cài đặt Liên hệ",
  Biolink_Page: "Trang Biolink",
  Qr_code: "Mã QR",
  analytics: "Phân tích tích hợp",
  destination: "Đích",
  purchased_Plan_monthly: "Bạn đã mua một Kế hoạch hàng tháng.",
  purchased_Plan_yearly: "Bạn đã mua một Kế hoạch hàng năm.",
  purchased_Plan_lifetime: "Bạn đã mua một Kế hoạch trọn đời",
  enjoy_your_plan: "Vui lòng thưởng thức kế hoạch trọn đời của bạn.",
  close: "Đóng",
  want_to_update_plan_yearly_lifetime:
    "Bạn có muốn cập nhật kế hoạch hàng năm hoặc trọn đời của mình không?",
  want_to_update_plan_lifetime:
    "Bạn có muốn cập nhật kế hoạch trọn đời của mình không?",
  updating_plan: "Đang cập nhật Kế hoạch",
  powered_by: "Được cung cấp bởi",
  text: "Văn bản",
  round: "Tròn",
  rounded: "Bo tròn",
  straight: "Thẳng",
  solid: "Chặt chẽ",
  dashed: "Nét đứt",
  double: "Đôi",
  outset: "Bắt đầu",
  inset: "Nhúng",
  border_width: "Chiều rộng biên giới",
  border_color: "Màu biên giới",
  border_style: "Kiểu biên giới",
  infinite: "Vô tận",
  bg_color: "Màu nền",
  animation: "Hoạt hình",
  animation_runs: "Hoạt hình Chạy",
  bounce: "Bounce",
  tada: "Tada",
  wobble: "Wobble",
  swing: "Swing",
  rubberband: "Rubberband",
  pulse: "Pulse",
  flash: "Flash",
  bounce_in: "BounceIn",
  fade_in: "FadeIn",
  small: "Nhỏ",
  medium: "Trung bình",
  large: "Lớn",
  img_thumbnail: "Ảnh thu nhỏ",
  email_address: "Địa chỉ Email",
  pass: "Mật khẩu",
  forgot_password: "Quên mật khẩu?",
  forgot_desc: "Đừng lo lắng! Điều này xảy ra.",
  forgot_description:
    "Vui lòng nhập địa chỉ email liên kết với tài khoản của bạn.",
  login: "Đăng nhập",
  remember_me: "Ghi nhớ tôi",
  send_request: "Gửi Yêu cầu",
  back: "Quay lại",
  dashboard: "Bảng điều khiển",
  plans: "Kế hoạch",
  taxes: "Thuế",
  website_settings: "Cài đặt trang web",
  languages: "Ngôn ngữ",
  language_code: "Mã ngôn ngữ",
  verify: "Xác minh",
  tweet_id: "ID Tweet",
  divider: "Dấu chia",
  add_divider: "THÊM DẤU CHIA",
  seo: "SEO",
  image_grid: "Lưới Ảnh",
  codes_management: "Quản lý Mã",
  create_tax: "Tạo Thuế",
  redeemed: "Đã đổi",
  quantity: "Số lượng",
  discount: "Giảm giá",
  tax: "Thuế",
  billing_for: "Lập hóa đơn cho",
  taxes_management: "Quản lý Thuế",
  random_discription: "Mô tả ngẫu nhiên cho một phí hỗ trợ.",
  personal_business: "Cá nhân & Doanh nghiệp",
  exclusive: "Độc quyền",
  support_fee: "Phí hỗ trợ",
  call_to_action: "Lời kêu gọi hành động",
  language: "Ngôn ngữ",
  users: "Người dùng",
  add_plan: "Thêm Kế Hoạch",
  interval_count: "Số Lần Khoảng Cách",
  interval: "Khoảng Cách",
  trial_days: "Ngày Thử Nghiệm",
  year: "năm",
  month: "tháng",
  countries: {
    afghanistan: "🇦🇫 Afghanistan",
    aland_islands: "🇦🇽 Quần đảo Aland",
    albania: "🇦🇱 Albania",
    algeria: "🇩🇿 Algeria",
    american_samoa: "🇦🇸 American Samoa",
    andorra: "🇦🇩 Andorra",
    angola: "🇦🇴 Angola",
    anguilla: "🇦🇮 Anguilla",
    antarctica: "🇦🇶 Antarctica",
    antigua_barbuda: "🇦🇬 Antigua và Barbuda",
    argentina: "🇦🇷 Argentina",
    armenia: "🇦🇲 Armenia",
    aruba: "🇦🇼 Aruba",
    australia: "🇦🇺 Australia",
    austria: "🇦🇹 Austria",
    azerbaijan: "🇦🇿 Azerbaijan",
    bahamas: "🇧🇸 Bahamas",
    bahrain: "🇧🇭 Bahrain",
    bangladesh: "🇧🇩 Bangladesh",
    barbados: "🇧🇧 Barbados",
    belarus: "🇧🇾 Belarus",
    belgium: "🇧🇪 Belgium",
    belize: "🇧🇿 Belize",
    benin: "🇧🇯 Benin",
    bermuda: "🇧🇲 Bermuda",
    bhutan: "🇧🇹 Bhutan",
    bolivia: "🇧🇴 Bolivia",
    eustatius_saba: "🇧🇶 Bonaire, Sint Eustatius và Saba",
    bosnia_herzegovina: "🇧🇦 Bosnia và Herzegovina",
    botswana: "🇧🇼 Botswana",
    bouvet_island: "🇧🇻 Quần đảo Bouvet",
    brazil: "🇧🇷 Brazil",
    british_indian: "🇮🇴 Lãnh thổ Ấn Độ thuộc Anh",
    brunei_darussalam: "🇧🇳 Brunei Darussalam",
    bulgaria: "🇧🇬 Bulgaria",
    burkina_faso: "🇧🇫 Burkina Faso",
    burundi: "🇧🇮 Burundi",
    cambodia: "🇰🇭 Campuchia",
    cameroon: "🇨🇲 Cameroon",
    canada: "🇨🇦 Canada",
    cape_verde: "🇨🇻 Cape Verde",
    cayman_islands: "🇰🇾 Quần đảo Cayman",
    central_african: "🇨🇫 Cộng hòa Trung Phi",
    chad: "🇹🇩 Chad",
    chile: "🇨🇱 Chile",
    china: "🇨🇳 Trung Quốc",
    christmas_island: "🇨🇽 Quần đảo Christmas",
    cocos_islands: "🇨🇨 Quần đảo Cocos (Keeling)",
    colombia: "🇨🇴 Colombia",
    comoros: "🇰🇲 Comoros",
    congo: "🇨🇬 Congo",
    democratic_republic: "🇨🇩 Cộng hòa Dân chủ Congo",
    cook_islands: "🇨🇰 Quần đảo Cook",
    costa_rica: "🇨🇷 Costa Rica",
    cote_ivoire: "🇨🇮 Côte d'Ivoire",
    croatia: "🇭🇷 Croatia",
    cuba: "🇨🇺 Cuba",
    curacao: "🇨🇼 Curaçao",
    cyprus: "🇨🇾 Cyprus",
    czech_republic: "🇨🇿 Cộng hòa Séc",
    denmark: "🇩🇰 Đan Mạch",
    djibouti: "🇩🇯 Djibouti",
    dominica: "🇩🇲 Dominica",
    dominican_republic: "🇩🇴 Cộng hòa Dominica",
    ecuador: "🇪🇨 Ecuador",
    egypt: "🇪🇬 Ai Cập",
    el_salvador: "🇸🇻 El Salvador",
    equatorial_guinea: "🇬🇶 Guinea Xích Đạo",
    eritrea: "🇪🇷 Eritrea",
    estonia: "🇪🇪 Estonia",
    ethiopia: "🇪🇹 Ethiopia",
    falkland_islands: "🇫🇰 Quần đảo Falkland (Malvinas)",
    faroe_islands: "🇫🇴 Quần đảo Faroe",
    fiji: "🇫🇯 Fiji",
    finland: "🇫🇮 Phần Lan",
    france: "🇫🇷 Pháp",
    french_guiana: "🇬🇫 Guiana Pháp",
    french_polynesia: "🇵🇫 Polynesia Pháp",
    southern_territories: "🇹🇫 Lãnh thổ miền Nam Pháp",
    gabon: "🇬🇦 Gabon",
    gambia: "🇬🇲 Gambia",
    georgia: "🇬🇪 Georgia",
    germany: "🇩🇪 Đức",
    ghana: "🇬🇭 Ghana",
    gibraltar: "🇬🇮 Gibraltar",
    greece: "🇬🇷 Hy Lạp",
    greenland: "🇬🇱 Greenland",
    grenada: "🇬🇩 Grenada",
    guadeloupe: "🇬🇵 Guadeloupe",
    guam: "🇬🇺 Guam",
    guatemala: "🇬🇹 Guatemala",
    guernsey: "🇬🇬 Guernsey",
    guinea: "🇬🇳 Guinea",
    guinea_bissau: "🇬🇼 Guinea-Bissau",
    guyana: "🇬🇾 Guyana",
    haiti: "🇭🇹 Haiti",
    heard_island: "🇭🇲 Đảo Heard và Quần đảo McDonald",
    holy_see: "🇻🇦 Thánh chí Vatican (Quốc gia Vatican)",
    honduras: "🇭🇳 Honduras",
    hong_kong: "🇭🇰 Hồng Kông",
    hungary: "🇭🇺 Hungary",
    iceland: "🇮🇸 Iceland",
    india: "🇮🇳 Ấn Độ",
    indonesia: "🇮🇩 Indonesia",
    iran_islamic: "🇮🇷 Iran, Cộng hòa Hồi giáo Iran",
    iraq: "🇮🇶 Iraq",
    ireland: "🇮🇪 Ireland",
    isle_man: "🇮🇲 Isle of Man",
    israel: "🇮🇱 Israel",
    italy: "🇮🇹 Ý",
    jamaica: "🇯🇲 Jamaica",
    japan: "🇯🇵 Nhật Bản",
    jersey: "🇯🇪 Jersey",
    jordan: "🇯🇴 Jordan",
    kazakhstan: "🇰🇿 Kazakhstan",
    kenya: "🇰🇪 Kenya",
    kiribati: "🇰🇮 Kiribati",
    korea_democratic: "🇰🇵 Cộng hòa Dân chủ Nhân dân Triều Tiên",
    korea_republic: "🇰🇷 Cộng hòa Hàn Quốc",
    kosovo: "🇽🇰 Kosovo",
    kuwait: "🇰🇼 Kuwait",
    kyrgyzstan: "🇰🇬 Kyrgyzstan",
    lao_people: "🇱🇦 Cộng hòa Dân chủ Nhân dân Lào",
    latvia: "🇱🇻 Latvia",
    lebanon: "🇱🇧 Lebanon",
    lesotho: "🇱🇸 Lesotho",
    liberia: "🇱🇷 Liberia",
    libyan_arab: "🇱🇾 Cộng hòa Arab Libya",
    liechtenstein: "🇱🇮 Liechtenstein",
    lithuania: "🇱🇹 Lithuania",
    luxembourg: "🇱🇺 Luxembourg",
    macao: "🇲🇴 Macao",
    macedonia_former: "🇲🇰 Macedonia, Cộng hòa cũ người Nam Tư",
    madagascar: "🇲🇬 Madagascar",
    malawi: "🇲🇼 Malawi",
    malaysia: "🇲🇾 Malaysia",
    maldives: "🇲🇻 Maldives",
    mali: "🇲🇱 Mali",
    malta: "🇲🇹 Malta",
    marshall_islands: "🇲🇭 Quần đảo Marshall",
    martinique: "🇲🇶 Martinique",
    mauritania: "🇲🇷 Mauritania",
    mauritius: "🇲🇺 Mauritius",
    mayotte: "🇾🇹 Mayotte",
    mexico: "🇲🇽 Mexico",
    micronesia_federated: "🇫🇲 Micronesia, Các quốc đảo Liên bang",
    moldova_republic: "🇲🇩 Moldova, Cộng hòa của",
    monaco: "🇲🇨 Monaco",
    mongolia: "🇲🇳 Mongolia",
    montenegro: "🇲🇪 Montenegro",
    montserrat: "🇲🇸 Montserrat",
    morocco: "🇲🇦 Morocco",
    mozambique: "🇲🇿 Mozambique",
    myanmar: "🇲🇲 Myanmar",
    namibia: "🇳🇦 Namibia",
    nauru: "🇳🇷 Nauru",
    nepal: "🇳🇵 Nepal",
    netherlands: "🇳🇱 Hà Lan",
    netherlands_antilles: "🇦🇳 Quần đảo Hà Lan",
    new_caledonia: "🇳🇨 New Caledonia",
    new_zealand: "🇳🇿 New Zealand",
    nicaragua: "🇳🇮 Nicaragua",
    niger: "🇳🇪 Niger",
    nigeria: "🇳🇬 Nigeria",
    niue: "🇳🇺 Niue",
    norfolk_island: "🇳🇫 Đảo Norfolk",
    northern_mariana: "🇲🇵 Quần đảo Bắc Mariana",
    norway: "🇳🇴 Na Uy",
    oman: "🇴🇲 Oman",
    pakistan: "🇵🇰 Pakistan",
    palau: "🇵🇼 Palau",
    palestinian_territory: "🇵🇸 Lãnh thổ Palestine, Được kiểm soát",
    panama: "🇵🇦 Panama",
    papua_new: "🇵🇬 Papua New Guinea",
    paraguay: "🇵🇾 Paraguay",
    peru: "🇵🇪 Peru",
    philippines: "🇵🇭 Philippines",
    pitcairn: "🇵🇳 Pitcairn",
    poland: "🇵🇱 Ba Lan",
    portugal: "🇵🇹 Bồ Đào Nha",
    puerto_rico: "🇵🇷 Puerto Rico",
    qatar: "🇶🇦 Qatar",
    reunion: "🇷🇪 Réunion",
    romania: "🇷🇴 Romania",
    russian_federation: "🇷🇺 Nga",
    rwanda: "🇷🇼 Rwanda",
    saint_barthelemy: "🇧🇱 Saint Barthelemy",
    saint_helena: "🇸🇭 Saint Helena",
    saint_kitts: "🇰🇳 Saint Kitts và Nevis",
    saint_lucia: "🇱🇨 Saint Lucia",
    saint_martin: "🇲🇫 Saint Martin",
    saint_pierre: "🇵🇲 Saint Pierre và Miquelon",
    saint_vincent: "🇻🇨 Saint Vincent và Grenadines",
    samoa: "🇼🇸 Samoa",
    san_marino: "🇸🇲 San Marino",
    sao_tome: "🇸🇹 Sao Tome và Principe",
    saudi_arabia: "🇸🇦 Arab Saudi",
    senegal: "🇸🇳 Senegal",
    serbia: "🇷🇸 Serbia",
    serbia_montenegro: "🇨🇸 Serbia và Montenegro",
    seychelles: "🇸🇨 Seychelles",
    sierra_leone: "🇸🇱 Sierra Leone",
    singapore: "🇸🇬 Singapore",
    sint_maarten: "🇸🇽 Sint Maarten",
    slovakia: "🇸🇰 Slovakia",
    slovenia: "🇸🇮 Slovenia",
    solomon_islands: "🇸🇧 Quần đảo Solomon",
    somalia: "🇸🇴 Somalia",
    south_africa: "🇿🇦 Nam Phi",
    south_georgia: "🇬🇸 Nam Georgia và Quần đảo Sandwich Nam",
    south_sudan: "🇸🇸 Nam Sudan",
    spain: "🇪🇸 Tây Ban Nha",
    sri_lanka: "🇱🇰 Sri Lanka",
    sudan: "🇸🇩 Sudan",
    suriname: "🇸🇷 Suriname",
    svalbard_jan: "🇸🇯 Svalbard và Jan Mayen",
    swaziland: "🇸🇿 Swaziland",
    sweden: "🇸🇪 Thụy Điển",
    switzerland: "🇨🇭 Thụy Sĩ",
    syrian_arab: "🇸🇾 Cộng hòa Arab Syria",
    taiwan_province: "🇹🇼 Đài Loan, Tỉnh của Trung Quốc",
    tajikistan: "🇹🇯 Tajikistan",
    tanzania_united: "🇹🇿 Tanzania, Cộng hòa Thống nhất của",
    thailand: "🇹🇭 Thái Lan",
    timor_leste: "🇹🇱 Timor-Leste",
    togo: "🇹🇬 Togo",
    tokelau: "🇹🇰 Tokelau",
    tonga: "🇹🇴 Tonga",
    trinidad_tobago: "🇹🇹 Trinidad và Tobago",
    tunisia: "🇹🇳 Tunisia",
    turkey: "🇹🇷 Thổ Nhĩ Kỳ",
    turkmenistan: "🇹🇲 Turkmenistan",
    turks_caicos: "🇹🇨 Quần đảo Turks và Caicos",
    tuvalu: "🇹🇻 Tuvalu",
    uganda: "🇺🇬 Uganda",
    ukraine: "🇺🇦 Ukraine",
    united_arab: "🇦🇪 Các Tiểu vương quốc Ả Rập Thống nhất",
    united_kingdom: "🇬🇧 Vương quốc Anh",
    united_states: "🇺🇸 Hoa Kỳ",
    unitedStates_minor: "🇺🇲 Các đảo nhỏ xa của Hoa Kỳ",
    uruguay: "🇺🇾 Uruguay",
    uzbekistan: "🇺🇿 Uzbekistan",
    vanuatu: "🇻🇺 Vanuatu",
    venezuela: "🇻🇪 Venezuela",
    viet_nam: "🇻🇳 Việt Nam",
    virgin_islands: "🇻🇬 Quần đảo Virgin, Anh",
    islands_us: "🇻🇮 Quần đảo Virgin, Mỹ",
    wallis_futuna: "🇼🇫 Wallis và Futuna",
    western_sahara: "🇪🇭 Sahara phía Tây",
    yemen: "🇾🇪 Yemen",
    zambia: "🇿🇲 Zambia",
    zimbabwe: "🇿🇼 Zimbabwe",
  },
  create_code: "Tạo Mã",
  create_newCode: "Tạo Mã Mới",
  miscellaneous: {
    tweel_url: "Thêm Đường Link Tweet",
    divider: "Dấu Chia Cách",
    divider_cap: "DẤU CHIA CÁCH",
    add_share: "Thêm Khối Chia Sẻ",
    add_countdown: "THÊM ĐẾM NGƯỢC",
    edit_countdown: "CHỈNH SỬA ĐẾM NGƯỢC",
    enter_countdown_description: "Nhập Mô Tả Đếm Ngược",
    date_time: "Ngày & Giờ",
    add_action: "Thêm Một Hành Động",
    add_faq: "Thêm Câu Hỏi Thường Gặp",
    email_me: "Gửi Email cho Tôi",

    discount_plan: "Chọn một giảm giá từ 1% đến 99% cho mã",
    bulk_generator: "Generator Hàng Loạt",
  },

  edit_taxes: {
    create_new: "Tạo Một Thuế Mới",
    created_tax:
      "Sau khi tạo một loại thuế, nó không thể được chỉnh sửa hoặc xóa. Sau khi tạo xong, bạn có thể liên kết nó với các Kế hoạch bạn đã tạo.",
    percentage: "Phần trăm",
    taxes: "Thuế",
    edittax: "Chỉnh Sửa Thuế",
    edit: "Chỉnh Sửa",
    edit_cap: "CHỈNH SỬA",
    description: "Mô Tả",
    tax_value: "Giá Trị Thuế",
    value_type: "Loại Giá Trị",
    fixed: "Cố Định",
    inclusive: "Bao Gồm",
    exclusive: "Loại Trừ",
    personal_only: "Chỉ Cá Nhân",
    business_only: "Chỉ Doanh Nghiệp",
    personal_business: "Cá Nhân & Doanh Nghiệp",
    billing_for: "Lập Hóa Đơn Cho",
    countries: "Quốc Gia",

    select:
      "Chọn các quốc gia bạn muốn áp dụng thuế này. Để trống nếu bạn muốn áp dụng thuế cho tất cả các quốc gia.",
  },
  planss: {
    edit_plan: "Chỉnh Sửa Kế Hoạch",
    plan_features: "Tính Năng Kế Hoạch",
    set: "Thiết Lập",
    for_unlimited: "cho không giới hạn",
    total_amoutpage: "Tổng số trang Biolink mà người dùng có thể tạo.",
    total_shortlink: "Tổng số liên kết rút gọn mà người dùng có thể tạo.",
    total_filelink: "Tổng số liên kết tệp mà người dùng có thể tạo.",
    vcard_Limit: "Giới Hạn Liên Kết Vcard",
    totl_vcard: "Tổng số liên kết Vcard mà người dùng có thể tạo.",
    total_eventlinks: "Tổng số liên kết sự kiện mà người dùng có thể tạo.",
    total_domain: "Tổng số tên miền tùy chỉnh mà người dùng có thể thêm.",
    link_state: "Bao lâu sẽ giữ lại thống kê liên kết trong cơ sở dữ liệu.",
    enable_blocks: "Blox Biolink Được Kích Hoạt",
    select_blocks:
      "Chọn những khối trang biolink được kích hoạt để sử dụng trong kế hoạch này.",
    state_retention: "Giữ Thống Kê Liên Kết (ngày)",
    custom_domain: "Giới Hạn Tên Miền Tùy Chỉnh",
    event_limit: "Giới Hạn Liên Kết Sự Kiện",
    file_limit: "Giới Hạn Liên Kết Tệp",
    link_limit: "Giới Hạn Liên Kết",
    blocks_limit: "Giới Hạn Khối Biolink mỗi trang biolink",
    biolink_limit: "Giới Hạn Biolinks",
    qr_limit: "Giới Hạn Mã QR",
    pixels_limits: "Giới Hạn Pixels",
    project_limits: "Giới Hạn Dự Án",
    additional_block: "Các Tên Miền Toàn Cầu Bổ Sung",
    additional_blockDes:
      "Kích hoạt tính năng này sẽ giúp mọi người có kế hoạch này có thể sử dụng tất cả các tên miền toàn cầu bổ sung.",
    back_half: "Back-half Tùy Chỉnh",
    back_halfDes:
      "Kích hoạt tính năng này sẽ cho phép người dùng có các đường dẫn URL tùy chỉnh thay vì tự động tạo.",
    deep_link: "Liên Kết Sâu",
    deep_linkDes:
      "Kích hoạt tính năng này sẽ cho phép người dùng sử dụng liên kết sâu để trỏ đến các ứng dụng cụ thể thay vì chỉ có địa chỉ URL http và https.",
    enable_ad:
      "Kích hoạt tính năng này sẽ khiến mọi người có kế hoạch này không thấy bất kỳ quảng cáo nào.",
    remove_brand: "Gỡ Bỏ Thương Hiệu Footer",
    remove_brandDes:
      "Tính năng này cho phép người dùng tùy chọn xóa thương hiệu từ chân trang biolinks.",
    button_url: "URL Nút Liên Hệ",
    description: "Mô Tả",
    phone_collector: "Bộ Sưu Tập Số Điện Thoại",
    email_collector: "Bộ Sưu Tập Email",
    paragraph: "Đoạn Văn",
    custom_branding: "Thương Hiệu Footer Tùy Chỉnh",
    custom_brandingDes:
      "Tính năng này cho phép người dùng thêm thương hiệu tùy chỉnh cho chân trang biolinks của họ.",
    colored_links: "Liên Kết Màu Sắc",
    colored_linksDes:
      "Cho phép người dùng tùy chỉnh màu sắc của các liên kết biolinks của họ.",
    advanced_statistics: "Thống Kê Nâng Cao",
    check_stat:
      "Cho phép người dùng kiểm tra thống kê chi tiết hơn và chọn khung thời gian.",
    custom_backgrounds: "Hình Nền Tùy Chỉnh",
    custom_backgroundDes:
      "Cho phép người dùng thêm hình nền tùy chỉnh cho trang biolinks của họ (màu sắc, chuyển động và hình ảnh thực).",
    temporary_URL: "URL Tạm Thời",
    temporary_urlDes:
      "Cho phép người dùng lên lịch các liên kết và giới hạn số lần nhấp.",
    seo_des:
      "Cho phép người dùng thay đổi Tiêu Đề và Mô Tả Meta của trang Biolink.",
    utm_des:
      "Cho phép người dùng thiết lập tham số UTM toàn cầu cho tất cả các liên kết bên trong một trang Biolink.",
    fonts_des:
      "Cho phép người dùng chọn một font theo sở thích từ danh sách font bổ sung.",
    password_protection: "Bảo Vệ Mật Khẩu",
    password_protectionDes:
      "Cho phép người dùng bảo vệ mật khẩu cho các liên kết của họ.",
    sensitive_content: "Cảnh Báo Nội Dung Nhạy Cảm",
    sensitive_contentDes:
      "Cho phép người dùng kích hoạt cảnh báo nội dung nhạy cảm cho các liên kết của họ.",
    leap_linkDes:
      "Cho phép người dùng chuyển hướng tạm thời các trang biolink đến một URL cụ thể.",
    dofollow_link: "Liên Kết Biolink Dofollow",
    dofollow_linkDes:
      "Liên kết biolink của người dùng sẽ có thuộc tính dofollow, ngược lại sẽ được đặt là nofollow mặc định.",
    rest_api: "Kích Hoạt Khả Năng Sử Dụng REST API",
    customcss_des:
      "Kích hoạt khả năng thêm CSS tùy chỉnh cho mỗi trang biolink. Hãy chắc chắn chỉ cho phép những người tin cậy sử dụng tính năng này.",
    customjs_des:
      "Kích hoạt khả năng thêm JS tùy chỉnh cho mỗi Vcard. Hãy chắc chắn chỉ cho phép những người tin cậy sử dụng tính năng này.",
    product_name: "Tên Sản Phẩm",
    order: "Đơn Hàng",
    plan_name: "Tên Kế Hoạch",
    action: "Hành Động",
  },

  filtermodal: {
    all: "Tất Cả",
    unconfirmed: "Chưa Xác Nhận",
    admin_created: "Admin Tạo",
    admin_api: "Admin API Tạo",
    facebook_login: "Đăng Nhập Bằng Facebook",
    twitter_login: "Đăng Nhập Bằng Twitter",
    discord_login: "Đăng Nhập Bằng Discord",
    google_login: "Đăng Nhập Bằng Google",
    registration_date: "Ngày Đăng Ký",
    ascending: "Tăng Dần",
    descending: "Giảm Dần",
    ten: "2",
    twentyfive: "3",
    fifty: "5",
    hundred: "7",
    twohundred: "10",
    fivehundred: "20",
    filters: "Bộ Lọc",
    order_by: "Sắp Xếp Theo",
    results_page: "Kết Quả Trên Mỗi Trang",
    created_datetime: "Ngày Giờ Tạo",
    redeemable: "Có Thể Đổi",
    dayss: "Ngày",
    external_payment: "ID Thanh Toán Bên Ngoài",
    paid: "Đã Thanh Toán",
    pending: "Đang Chờ",
    offline_payment: "Thanh Toán Ngoại Tuyến",
    coinbase: "Coinbase",
    payU: "PayU",
    paystack: "Paystack",
    razorpay: "Razorpay",
    mollie: "Mollie",
    yookassa: "Yookassa",
    crypto: "Crypto.com",
    paddle: "Paddle",
    monthly_payments: "Thanh Toán Hàng Tháng",
    missing_translation:
      "thiếu_dịch: quản trị_thanh toán.bộ lọc.đặt hàng_qua_tên",
    missing_translate:
      "thiếu_dịch: quản trị_thanh toán.bộ lọc.đặt hàng_qua_e-mail",
  },
  location: {
    addpin: "Thêm Địa Điểm",
    cancel_adding_pin: "Hủy Thêm Địa Điểm",
    adress: "Địa Chỉ",
    adress_placeholder: "123 Đường Main, Thành Phố",
    phone: "Điện Thoại",
    phone_placeholder: "123-456-7890",
    add_location: "Thêm Địa Điểm",
    set_primary: "Đặt Làm Chính",
    primary_location: "Địa Điểm Chính",
    get_directions: "Nhận Chỉ Đường",
  },

  report: {
    report_abuse: "Báo Cáo Lạm Dụng",
    page_url: "URL Trang",
    enter_page_url: "Nhập URL trang đang được báo cáo",
    report_type: "Loại Báo Cáo",
    reporter_type: "Loại Người Báo Cáo",
    additional_comment: "Bình Luận Bổ Sung",
    attachment: "Đính Kèm",
    select_report_type: "Chọn loại báo cáo",
    spam_scam_phishing: "Spam, Scam hoặc Phishing",
    adult_content: "Nội Dung Người Lớn",
    illegal_goods_services: "Hàng và Dịch Vụ Bất Hợp Pháp",
    fraud: "Gian Lận",
    child_abuse: "Lạm Dụng Trẻ Em",
    shocking_violent_content: "Nội Dung Gây Sốc hoặc Bạo Lực",
    privacy_impersonation_harassment: "Quyền Riêng Tư, Mạo Danh và Quấy Rối",
    gambling: "Cờ Bạc",
    select_reporter_type: "Chọn loại người báo cáo",
    bil_bio_user: "Người Dùng Bil Bio",
    non_bil_bio_user: "Người Dùng Non Bil Bio",
    legal_representative: "Đại Diện Pháp Lý",
    law_enforcement: "Lực Lượng Thực Hiện Luật Pháp",
    regulatory_body: "Cơ Quan Quy Regul",
    child_abuse: "Lạm Dụng Trẻ Em",
    shocking_violent_content: "Nội Dung Gây Sốc hoặc Bạo Lực",
    privacy_impersonation_harassment: "Quyền Riêng Tư, Mạo Danh và Quấy Rối",
    gambling: "Cờ Bạc",
    type_report_required: "Loại Báo Cáo là bắt buộc",
    type_reporter_required: "Loại Người Báo Cáo là bắt buộc",
    comment_required: "Bình Luận là bắt buộc",
    url_required: "URL Trang là bắt buộc",
    attachment_required: 'Cần có tệp đính kèm',
    report_sentence: "Với biểu mẫu này, bạn có thể báo cáo mọi hành vi lạm dụng tiểu sử",
    site_protected: "Trang web này được bảo vệ bởi reCAPTCHA và Google",
    apply: "áp dụng",
  },
  want_to_delete: "Bạn có chắc chắn muốn xóa điều này không?",
  get_started_now: "BẮT ĐẦU NGAY",
  join_waiting_list: "Tham gia danh sách chờ",
  package_suitable_people: "Gói này phù hợp cho nhóm 1-15 người.",
};

export default vn;
